import React from 'react';
import { createRoot } from 'react-dom/client';

import BrandsPageContainer from '../../../pages/BrandsPageContainer/BrandsPageContainer';

const container = document.getElementById('productsCatalog');
const root = createRoot(container!);
root.render(<BrandsPageContainer />);
